export enum SecondaryNavType {
  REGISTRY = 'registry',
  WEBSITE = 'website',
  PAPER = 'invites',
  GUEST_LIST = 'guestList',
  WEDDING_BOUTIQUE = 'weddingBoutique',
  ALBUMS = 'albums',
}
